interface PolygonIconProps {
  className?: string
  size?: number
  colored?: boolean
}

export const PolygonIcon: React.FC<PolygonIconProps> = ({
  className,
  size = 24,
  colored = false,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="66 80 268 240"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M264.655 248.73L327.913 211.838C331.263 209.89 333.333 206.252 333.333 202.34V128.554C333.333 124.643 331.247 121.004 327.913 119.056L264.655 82.1633C261.305 80.2158 257.15 80.2158 253.8 82.1633L190.542 119.056C187.192 121.004 185.122 124.643 185.122 128.554V260.417L140.764 286.278L96.4068 260.417V208.677L140.764 182.815L170.015 199.882V165.176L146.185 151.271C144.541 150.313 142.661 149.802 140.764 149.802C138.868 149.802 136.972 150.313 135.344 151.271L72.0868 188.163C68.7368 190.112 66.6666 193.752 66.6666 197.662V271.447C66.6666 275.343 68.7526 278.998 72.0868 280.947L135.344 317.838C138.694 319.787 142.85 319.787 146.2 317.838L209.458 280.947C212.808 278.998 214.878 275.358 214.878 271.447V139.586L215.683 139.123L259.235 113.724L303.593 139.586V191.325L259.235 217.187L230.017 200.153V234.858L253.8 248.73C257.15 250.678 261.305 250.678 264.655 248.73Z"
        fill={colored ? '#7B3FE4' : 'currentColor'}
      />
    </svg>
  )
}
